import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-section-alt py-16 md:py-24 px-4" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-navy text-cream p-8 md:p-12 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-96">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 opacity-10" data-id="element-97">
            <ShieldCheckIcon className="w-64 h-64" data-id="element-98" />
          </div>

          <div className="relative z-10" data-id="element-99">
            <ShieldCheckIcon className="w-12 h-12 text-amber mb-6" data-id="element-100" />
            <p className="font-body text-lg md:text-xl leading-relaxed" data-id="element-101">
              En solo 7 días, pasarás de ser el "enemigo" que interroga al
              "aliado" que acompaña. No prometemos que la depresión desaparecerá
              mágicamente, pero garantizamos que la comunicación volverá a
              fluir, abriendo la puerta para que la verdadera sanación comience.
              Lo que cambia en una semana es la atmósfera de tu hogar: del miedo
              y la tensión a la paz y la conexión.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}